import { Outlet } from 'react-router-dom'

interface Props {
};

export function Category(props: Props) {
    return (
        <div className="category">
            <Outlet />
        </div>
    )
}
